module.exports = __webpack_public_path__ + "static/media/done_blue.fd689083.svg";